export default "__VITE_ASSET__BeCpIP9y__"